module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_5010.d7c7ab7c.png";